import firebase from 'firebase/compat/app';
import "firebase/compat/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from 'firebase/firestore/lite';
import ReactObserver from 'react-event-observer';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from "firebase/analytics";

// Firebase config - PR
export const firebaseConfig = {
  apiKey: "AIzaSyAgLhvJgUzUnnMY5iLB9oF6IxZgDF3Z22k",
  authDomain: "prod-main-ph-timekeeping.firebaseapp.com",
  projectId: "prod-main-ph-timekeeping",
  storageBucket: "prod-main-ph-timekeeping.appspot.com",
  messagingSenderId: "135382382678",
  appId: "1:135382382678:web:da991867adf05cf19a63f7",
  measurementId: "G-7DNFGW5FPE"
};

export const app = firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, process.env.REACT_APP_FIREBASE_REGION);
export const analytics = getAnalytics(app);

export const firebaseObserver = ReactObserver();
firebase.auth().onAuthStateChanged(function(user) {
  if (user) {
    user.getIdTokenResult().then(function(data) {
      firebaseObserver.publish("userAuthContext",
        {
          displayName: user.displayName,
          role: data.claims?.role,
          tenantId: data.claims?.tenantId
        }
      );
    });
  } else {
    firebaseObserver.publish("userAuthContext",
      null
    );
  }
});
